class KPIWidgetResultVM extends BaseResultVM {
    indicatorValue: number;
    targetValue: number;
    format: FieldFormatEnum;
    currencySymbol: string;
    currencyCode: string;
    hasData: boolean;
    trendValues: Array<KPIData> = new Array<KPIData>();

    itemConfig: KPIConfig;

    constructor(result, itemConfig: KPIConfig) {
        super(result);

        let self = this;
        self.itemConfig = itemConfig;

        self.indicatorValue = result.indicatorValue;
        self.targetValue = result.targetValue;
        self.format = result.format;
        self.currencySymbol = result.currencySymbol;
        self.currencyCode = result.currencyCode;
        self.hasData = result.hasData;
        self.trendValues = result.trendValues;
    }
}

class KPIData {
    constructor(axisValue: string, indicatorValue: number, targetValue: number) {
        this.axisValue = axisValue;
        this.indicatorValue = indicatorValue;
        this.targetValue = targetValue;
    }

    axisValue: string;
    indicatorValue: number;
    targetValue: number;
}